import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import yes from "../../assets/yes.svg";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
export default function FeaturesHeroCard({
  bgColor = "#F5FAFF",
  image,
  imagePosition = "left",
  title,
  description,
  features = [],
  titleVariant = "h4",
  descriptionVariant = "body5",
  sx = {},
    imageSx = {}, 
}) {
  const isImageLeft = imagePosition === "left";
  const isImageTop = imagePosition === "top";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <Box
      sx={{
        backgroundColor: bgColor,
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 8, lg: 10 },
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          // flexDirection: { xs: "column", md: isImageLeft ? "row" : "row-reverse" },
          flexDirection: {
            xs: "column",
            md: isImageTop ? "column" : isImageLeft ? "row" : "row-reverse",
          },
          alignItems: "center",
          gap: 6,
        }}
      >
        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Box
            component="img"
            src={image}
            alt={title}
            sx={{
              width: "88%",
              // maxWidth: "600px",
              // height: "100%",
            height:"auto",
              // maxHeight: "560px",
              objectFit:"contain",
                  ...imageSx, 
            }}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <CustomText
            variant={titleVariant}
            style={{
              ...textStyles.h1,
              marginBottom: isMobile ? "0.5rem" : "1rem",
              marginTop: isMobile ? "0rem" : "1rem",
              fontSize: isMobile ? "30px" : "36px",
              textAlign: "left",
            }}
          >
            {title}
          </CustomText>
          <CustomText
            variant={descriptionVariant}
            style={{
              ...textStyles.body1,
              color: "#868282",
              //  maxWidth: "1175px",
              margin: "0 auto",
              marginTop: "10px",
              textAlign: "left",
              fontSize: "24px",
              lineHeight: "120%",
            }}
          >
            {description}
          </CustomText>
          {features && features.length > 0 && (
            <Box
              sx={{
                mt: 4,
                backgroundColor: "#fff",
                borderRadius: 3,
                px: 0,
                py: 1,
                maxWidth: 500,
                border: "1px solid #DFDFDF",
              }}
            >
              <List dense>
                {features.map((item, index) => (
                  <ListItem
                    key={index}
                    sx={{ py: 0.5, gap: 2, alignItems: "center" }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "20px", // reduce from default 40px
                        // aligns icon with first text line
                      }}
                    >
                      <img
                        src={yes}
                        alt="check"
                        style={{ width: 20, height: 20 }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: {
                          fontSize: "16px",
                          fontFamily: `'Nunito', sans-serif`,
                          color: "#212121",
                          fontWeight: 600,
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}



